import MerchantSimbartCommonApi from '@/api/merchant-common'
const state = {}

const mutations = {}

const actions = {
  /**
   * 哈希缓存 - 保存
   */
  async saveCacheData({ commit }, data) {
    const result = await MerchantSimbartCommonApi.saveCacheData(data)
    return result
  },
  /**
   * 哈希缓存 - 获取
   */
  async getCacheData({ commit }, params) {
    const result = await MerchantSimbartCommonApi.getCacheData(params)
    return result
  },
  /**
   * 小程序码生成
   */
  async generateMiniappCode({ commit }, params) {
    const result = await MerchantSimbartCommonApi.generateMiniappCode(params)
    return result
  },

  /**
   * 小程序链接生成
   */
  async generateMiniappURLLink({ commit }, params) {
    const result = await MerchantSimbartCommonApi.generateMiniappURLLink(params)
    return result
  },

  async generateManagerMiniappCode({ commit }, params) {
    const result = await MerchantSimbartCommonApi.generateManagerMiniappCode(params)
    return result
  },

  async generateManagerMiniappURLLink({ commit }, params) {
    const result = await MerchantSimbartCommonApi.generateManagerMiniappURLLink(params)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-common.js